import { buildGroupsAndLines } from './invoice-line-groups.mapper';

export class PreinvoiceSaveMapper {
  static mapItemsToGroupsAndLines(params: {
    items: any[];
    concepts: any[];
    taxes: any[];
  }) {
    return buildGroupsAndLines({
      items: params.items,
      concepts: params.concepts,
      taxes: params.taxes
    });
  }
}
